import { format, isValid, parse } from 'date-fns';

export const cleanDateField = (fieldValue: string) => {
	if (!fieldValue) {
		return '';
	}

	if (!isValid(parse(fieldValue, 'yyyy-MM-dd', new Date()))) {
		const alternateFormatDate = parse(fieldValue, 'MM/dd/yyyy', new Date());
		if (isValid(alternateFormatDate)) {
			return format(alternateFormatDate, 'yyyy-MM-dd');
		}

		return '';
	}

	return fieldValue;
};

const numberRegex = /^\d+(\.\d{1,2})?$/;
export const cleanNumberField = (fieldValue: string) => {
	if (!fieldValue) {
		return '';
	}

	const resultValue = fieldValue.replace('$', '');
	return numberRegex.test(resultValue) ? resultValue : '';
};
